// Service API
import authLoginService from "@/app/services/auth/auth-login/auth-login-service.js"
import userService from "@/app/services/main/user/user-service.js"

// Util
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Constants
import { GA } from "@/app/constants/ga-constants"
import { STATUS_CODES, STATUS_MSG, ERROR_MSG } from "@/app/constants/status-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

// Mixins
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

let jwt = require("jsonwebtoken")

export default {
	name: "AuthLogin",
	mixins: [GoogleAnalyticsMixins, toastMessageMixins],
	data() {
		return {
			email: "",
			password: "",
			showPassword: false,
			isAPILoading: false,
			nativeActivePet: null,
			referredRoute: this.$route.query.from,
			isUserAgentMobile: false,
			mobileAppLink: "",
		}
	},
	computed: {
		validationRules() {
			let fields = {
				email: {},
				password: {},
			}
			fields = vuelidateUtil.setFieldsRequired(fields, true)
			fields = vuelidateUtil.setEmailValidation(fields, "email")
			return fields
		},
		authStatus() {
			return this.$store.getters.getAuthMessage
		},
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
	},
	async created() {
		this.isUserAgentMobile = this.getUserAgent()
		if (this.$route.query) {
			const { accessToken } = this.$route.query

			if (accessToken) {
				const userData = jwt.verify(
					accessToken,
					process.env.VUE_APP_NATIVE_SECRET,
					{ alg: "HS256" },
					(err, decoded) => {
						if (err) {
							this.showCustomErrorToast("Error", err)
							return null
						} else {
							return decoded
						}
					}
				)

				if (userData) {
					this.email = userData.email
					this.password = userData.password
					this.nativeActivePet = { id: userData.petId }

					this.$store.commit("setIsNativeApp", userData.isNativeApp)

					const routeMap = {
						social: "/social",
						post: `/post${userData.query}`,
						products: "/products",
						"product-list": `/products/product-list${userData.query}`,
						transactions: `/products/product-transactions${userData.query}`,
						"dog-purchase": `/buy-puppy`,
						"dog-transactions": `/purchases/dog-transactions${userData.query}`,
						"contact-us": `/contact-us`,
						checkout: `/products/checkout`,
						subscriptionCheckout: `/products/checkout${userData.query}`,
					}

					this.referredRoute = routeMap[userData.destination] || ""

					await this.onSignIn()
				}
			}
		}
	},
	methods: {
		sendForgotPassAnalytics() {
			// Custom Event Analytics Example
			this.sendEventTrackingToGA(
				`${GA.LOGIN.FORGOT_PASSWORD_LINK.ACTION}`,
				`${GA.LOGIN.CATEGORY}`,
				`${GA.LOGIN.FORGOT_PASSWORD_LINK.LABEL}`
			)
		},

		// Move Implementation to Success API of Google and FB
		sendSignInAnalytics(isFB) {
			let action = isFB ? GA.LOGIN.SIGN_IN_WITH_FB.ACTION : GA.LOGIN.SIGN_IN_WITH_GOOGLE.ACTION
			let label = isFB ? GA.LOGIN.SIGN_IN_WITH_FB.LABEL : GA.LOGIN.SIGN_IN_WITH_GOOGLE.LABEL

			this.sendEventTrackingToGA(action, GA.LOGIN.CATEGORY, label)
		},
		sendSignUpAnalytics() {
			this.sendEventTrackingToGA(GA.LOGIN.SIGN_UP.ACTION, GA.LOGIN.CATEGORY, GA.LOGIN.SIGN_UP.LABEL)
		},


		async onSignIn(event) {
			if (event && event.preventDefault) {
				event.preventDefault();
			}
			this.isAPILoading = true

			const authDetails = {
				email: this.email,
				password: this.password,
			}

			this.commitAuthMessage("", "")
			const authUserData = await authLoginService.putAuthLogin(authDetails)
			if (authUserData.data.status === STATUS_MSG.AUTH_SERVICE_STATUS_SUCCESS_MSG) {
				// Save JWT to lmdc-user store
				this.$store.commit("setUserToken", authUserData.data.jwt)
				
				const userData = await userService.getLoggedInUser(this.email)
				if (userData.status === STATUS_CODES.SUCCESS) {
					const { userDetails } = userData.data
					
					if (userDetails.userRole === "SADM" || userDetails.userRole === "LADM") {
						this.isAPILoading = false
						this.commitAuthMessage(
							"failed",
							"You are not authorized to access this site. We will redirect you to the admin page."
						)
						this.$store.commit("clearUserToken")

						setTimeout(() => {
							window.location.href = process.env.VUE_APP_ADMIN_SITE
						}, 3000)
						return
					}

						const currentActivePet = this.nativeActivePet
							? this.nativeActivePet
							: this.$store.getters.getActivePet

						let activePet
						if (currentActivePet) {
							const findPet = userDetails.pets.find((pet) => pet.id === currentActivePet.id)
							activePet = findPet ? findPet : userDetails.pets[0]
						} else {
							activePet = userDetails.pets[0]
						}

						this.$store.commit("setActivePet", activePet)
						this.$store.commit("setUserDetails", userDetails)
						this.$store.dispatch("initializeLogoutTimer")
						this.isAPILoading = false

						if (this.referredRoute) {
							this.$router.push(this.referredRoute)
						} else if (userDetails.userRole === "BRDER") {
							this.$router.push(BREEDER_ROUTES.PUPPY_SALES)
						} else {
							this.$router.push("/dashboard")
						}

						this.sendEventTrackingToGA(
							`${GA.LOGIN.SIGN_IN_BUTTON.ACTION}`,
							`${GA.LOGIN.CATEGORY}`,
							`${GA.LOGIN.SIGN_IN_BUTTON.LABEL}`
						)
				} else {
					this.$store.commit("clearUserToken")
					this.isAPILoading = false
					if (userData.status === STATUS_CODES.UNAUTHORIZED) {
						this.commitAuthMessage(STATUS_CODES.UNAUTHORIZED, `Your account cannot be accessed. Please email services@lovemydogclub.com.au`)
					} else {
						this.commitAuthMessage("failed", 'Incorrect Credentials')
					}
				}
			} else {
				this.isAPILoading = false
				this.commitAuthMessage("failed", authUserData.data.message)
			}
		},
		
		getErrorMessage(res) {
			let message = ""

			if (res.status === STATUS_CODES.BAD_REQUEST || res.status === STATUS_CODES.UNAUTHORIZED) {
				message = res.data.errors[0].message
			} else {
				message = ERROR_MSG.INTERNAL_ERROR
			}

			return message
		},
		commitAuthMessage(status, message) {
			this.$store.commit("setAuthMessage", { status, message })
		},
		redirectLanding() {
			this.$router.push("/")
		},
		getUserAgent() {
			const userAgent = navigator.userAgent

			if (userAgent.includes("Android")) {
				this.mobileAppLink =
					"https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.lmdcmobile&ddl=1&pcampaignid=web_ddl_1"
				return true
			} else if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
				this.mobileAppLink = "https://apps.apple.com/us/app/id1523977343"
				return true
			}

			return false
		},
		setMobileStoreLink() {
			window.location.href = this.mobileAppLink
		},
		setShowPassword() {
			this.showPassword = !this.showPassword
		},
	},
	validations() {
		return this.validationRules
	},
}
